import React, { useEffect, useState, useRef } from 'react';
import { scaleBanner } from '@/client/utils/bannerResizer';

interface BannerProps {
  position: string;
  type: string;
  enableResizer?: boolean;
}

const BannerListItem: React.FC<BannerProps> = ({ position, type, enableResizer = false }) => {
  const [mounted, setMounted] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted || !enableResizer) return;

    const container = containerRef.current;
    const wrapper = wrapperRef.current;
    if (!container || !wrapper) return;

    const applyScaling = () => scaleBanner(container, wrapper);

    const mutationObserver = new MutationObserver(applyScaling);
    mutationObserver.observe(container, { childList: true, subtree: true });

    // GPT inserts the iframe before sizing it on slow networks; the container's resize
    // catches that (and viewport changes). The scale is a transform, so no feedback loop.
    const resizeObserver = new ResizeObserver(applyScaling);
    resizeObserver.observe(container);

    applyScaling();

    return () => {
      mutationObserver.disconnect();
      resizeObserver.disconnect();
    };
  }, [mounted, enableResizer]);

  if (!mounted) {
    return null;
  }

  return (
    <div ref={wrapperRef} className={`hz-Banner hz-Banner--${type}`}>
      <div ref={containerRef} id={`banner-${position}`} />
    </div>
  );
};

export default BannerListItem;
